/**
 * Cart drawer quantity controls  (dev request 3)
 *
 * The drawer previously offered only a remove (x) button, so a customer could not
 * take one unit off a line without going back to the PDP.
 *
 * WHY THIS IS A SEPARATE, UNHASHED FILE: assets/ is bundler output whose source
 * project is not in this repo, so CartDrawer-*.js cannot be edited safely. It does
 * not need to be. The drawer already re-renders itself from section HTML whenever
 * `customer:cart` fires, and WIP.Utils.changeCartItemByKey fires that event after
 * every /cart/change.js call. So this file only has to translate a click into a
 * quantity, and the existing component redraws the result.
 *
 * Listeners are delegated from `document` rather than bound to the buttons, because
 * the drawer replaces its own innerHTML on every update - anything bound directly
 * to a button would be discarded on the first change.
 */
(function () {
  'use strict';

  var ACTION_SELECTOR = '[data-cart-qty-action]';
  var busy = false;

  function cartUtils() {
    var wip = window.WIP;
    if (!wip || !wip.Utils || typeof wip.Utils.changeCartItemByKey !== 'function') {
      return null;
    }
    return wip.Utils;
  }

  /**
   * Gift wrap and other addons are separate cart lines tied to their parent by a
   * `_parent` property, surfaced in the markup as a hidden hiddenAddon-<key> input.
   * They have to move with the parent, or a customer ends up paying for three
   * pillows and one wrap. Same lookup the drawer's own remove handler uses.
   */
  function addonKeyFor(lineKey) {
    var input = document.querySelector('[name="hiddenAddon-' + lineKey + '"]');
    return input && input.value ? input.value : null;
  }

  function nextQuantity(button) {
    var current = parseInt(button.getAttribute('data-quantity'), 10);
    var step = parseInt(button.getAttribute('data-step'), 10);
    var min = parseInt(button.getAttribute('data-min'), 10);
    var rawMax = button.getAttribute('data-max');
    var max = rawMax ? parseInt(rawMax, 10) : NaN;

    if (isNaN(current)) return null;
    if (isNaN(step) || step < 1) step = 1;
    if (isNaN(min) || min < 1) min = 1;

    var increasing = button.getAttribute('data-cart-qty-action') === 'increase';

    if (increasing) {
      var up = current + step;
      if (!isNaN(max) && up > max) return null;
      return up;
    }

    // Stepping below the line's minimum removes it, which is what the x button
    // does and what customers expect from a stepper sitting at 1.
    var down = current - step;
    return down < min ? 0 : down;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest(ACTION_SELECTOR) : null;
    if (!button) return;

    event.preventDefault();
    if (busy) return;

    var utils = cartUtils();
    if (!utils) return;

    var lineKey = button.getAttribute('data-key');
    var quantity = nextQuantity(button);
    if (!lineKey || quantity === null) return;

    busy = true;
    button.setAttribute('aria-busy', 'true');

    var addonKey = addonKeyFor(lineKey);
    var pending = addonKey
      ? utils.changeCartItemByKey({ id: addonKey, quantity: quantity })
      : Promise.resolve();

    pending
      .then(function () {
        return utils.changeCartItemByKey({ id: lineKey, quantity: quantity });
      })
      .catch(function (error) {
        console.error('[cart-quantity] could not update line', lineKey, error);
      })
      .then(function () {
        busy = false;
        // The drawer has usually re-rendered by now, detaching this node. Harmless.
        button.removeAttribute('aria-busy');
      });
  });
})();
